import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiChatMessageService {
  private readonly messageToAppend$$ = new BehaviorSubject<string | null>(null);
  readonly messageToAppend$ = this.messageToAppend$$.asObservable();
  readonly messageToAppend = toSignal(this.messageToAppend$, { initialValue: null });

  setMessageToAppend(message: string): void {
    this.messageToAppend$$.next(message);
  }

  consumeMessageToAppend(): string | null {
    const message = this.messageToAppend$$.getValue();
    if (message) {
      this.messageToAppend$$.next(null);
    }
    return message;
  }
}
